import { render, staticRenderFns } from "./LatestNewsWidgetItem.vue?vue&type=template&id=ef307828&"
import script from "./LatestNewsWidgetItem.vue?vue&type=script&lang=js&"
export * from "./LatestNewsWidgetItem.vue?vue&type=script&lang=js&"
import style0 from "./LatestNewsWidgetItem.vue?vue&type=style&index=0&id=ef307828&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports